import { createSlice } from "@reduxjs/toolkit";
export const menuSlice = createSlice({
  name: "menuState",
  initialState: {
    value: {
      title: "Home",
      path: "/",
      description: "Welcome to home",
    },
  },
  reducers: {
    activeMenu: (state, action) => {
      state.value = action.payload;
    },
  },
});
export const { activeMenu } = menuSlice.actions;
export default menuSlice.reducer;
